import { t } from "@/i18n-js/instance";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";
import { templateLocaleNamespace } from "../UpsertTemplateModal/UpdateTemplateContent";

export const SaveTemplatePromptModal = ({
  isOpen,
  onClose,
  handleSaveAsTemplate,
}: {
  isOpen: boolean;
  onClose: () => void;
  handleSaveAsTemplate: () => void;
}) => (
  <ConfirmationModal
    isOpen={isOpen}
    onClose={onClose}
    onCancel={onClose}
    onConfirm={handleSaveAsTemplate}
    title={t([templateLocaleNamespace, "save_as_template_title"])}
    cancelText={t([templateLocaleNamespace, "continue_without_saving"])}
    confirmText={t([templateLocaleNamespace, "save_as_template"])}
  >
    {t([templateLocaleNamespace, "save_email_as_template_description"])}
  </ConfirmationModal>
);
